import { Flex } from '@chakra-ui/react';
import { ConceptNavigationContext } from '@bridge/navigationStore';
import { useTranslation } from 'react-i18next';
import { ClassicalBreadcrumb } from './ClassicalBreadcrumb';
import { ConceptBreadcrumbPicker } from './ConceptBreadcrumbPicker';
import { ContextNavigationItem } from './ContextNavigationItem';
import { ContextUtilityLinks } from './ContextUtilityLinks';
import { CurrentContextHeader } from './CurrentContextHeader';
import {
  conceptItems,
  conceptUtilityItems,
  isStateActive,
} from './navigationItems';

interface ConceptContextNavigationProps {
  activeState: string;
  context: ConceptNavigationContext;
}

export function ConceptContextNavigation({
  activeState,
  context,
}: ConceptContextNavigationProps) {
  const { t } = useTranslation();
  const params = { conceptId: context.concept.id };
  const translateLabel = (label: string) => t(label as 'navigation.articles');

  return (
    <>
      <ClassicalBreadcrumb
        items={[
          {
            label: context.customer.name,
            route: 'customer.articles',
            navobj: { customerId: context.customer.id },
          },
          {
            label: context.concept.name,
            content: (
              <ConceptBreadcrumbPicker context={context} isCurrent={true} />
            ),
          },
        ]}
      />
      <CurrentContextHeader
        archived={context.concept.archived}
        label={t('navigation.concept')}
        title={context.concept.name}
      />
      <ContextUtilityLinks
        activeState={activeState}
        items={conceptUtilityItems}
        navobj={params}
      />
      <Flex direction="column" pt={3}>
        {conceptItems.map((item) => (
          <ContextNavigationItem
            key={item.route}
            label={translateLabel(item.label)}
            route={item.route}
            navobj={params}
            active={isStateActive(activeState, item.route)}
          />
        ))}
      </Flex>
    </>
  );
}
